module.exports = __webpack_public_path__ + "static/media/logos_50h_tencent.5fb571e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/logo_bar/logos_50h_tencent.jpg
// module id = 226
// module chunks = 0